import React from "react";
import { Container } from "react-bootstrap";

const NotFound = () => {
	return <Container className="page-not-found"></Container>;
};

export default NotFound;
